import wx from 'weixin-js-sdk'
import { DATA } from '../data'
import { UA } from '../utils'
import { WEIXIN_BASE } from './base'
import { WEIXIN_CHAT } from './chat'
import { WEIXIN_PAY } from './pay'

//需在用户可能点击分享按钮前就先调用
var WEIXIN = {
    /**
     * 微信分享配置
     */
    initConfigShare(sucFunc, failFunc, updateShareTime) {
        var shareTimes = AppFate.$store.state.shareTimes;
            shareTimes = updateShareTime ? shareTimes+1 : 0;
            AppFate.$store.state.shareTimes = shareTimes;
        var curPath = AppFate.$router.history.current.path,
            userInfo = AppFate.$store.state.userData,
            detailData = AppFate.$store.state.detail,
            commentData = AppFate.$store.state.comment,
            discussData = AppFate.$store.state.discuss,
            otherShareData = AppFate.$store.state.othershare,
            donateData = AppFate.$store.state.donate,
            famouspediaData = AppFate.$store.state.famouspedia,
            marriageShareCode = AppFate.$store.state.marriage.marriageShareCode;

        WEIXIN_BASE.getAuthorationAndConfigJsSDK(function(){
            
            // 处理分享参数
            var baseTitle = '天时子平八字', hideName = false, newTitle = '', shareId = '';
            var WxShareData = {
                title: baseTitle,
                desc: '专业好用的八字软件；支持手机和电脑使用；让易学数据世代相传。',
                linkurl: 'https://' + location.hostname,
                img: 'https://' + location.hostname + '/dist/logo.png',
            }
            
            // document.title = baseTitle;
            console.log('shareconfig========path', curPath, detailData.personInfo, userInfo)

            // 处理命盘分享参数
            if (curPath.indexOf('detail') != -1 && detailData.personInfo.birthday) {
                hideName = detailData.personInfo.f_name == '匿名' || detailData.hideName ? true : false;
                newTitle = DATA.getSharedTextByData('wechat', hideName, detailData.personInfo);
                // document.title = newTitle;
                WxShareData.title = newTitle;
                WxShareData.desc = '点击可选择保存新八字。打开后点击右上角"..."选择"浮窗"可锁定八字防刷屏.支持多八字对比';
                shareId = hideName ? detailData.personInfo.share : detailData.personInfo.share2;
                WxShareData.linkurl = 'https://' + location.hostname + '/share/detail/' + shareId + '-save0';
            }

            // 处理批盘分享参数:自己的批盘
            if (curPath.indexOf('comment/detail') != -1 && detailData.personInfo.id) {
                // document.title = '我的批盘';
                WxShareData.title = DATA.getPipanSharedTextByData('wechat', commentData.hideName, userInfo, detailData.personInfo);;
                WxShareData.desc = '点击查看批盘内容。打开后可点击右上角『保存』将批盘内容保存到我的八字库中。';
                shareId = commentData.hideName ? commentData.shareCode.nmpishare : commentData.shareCode.smpishare;
                WxShareData.linkurl = 'https://' + location.hostname + '/share/comment/' + shareId;
                WxShareData.img = 'https://' + location.hostname + '/dist/share-img-2.png';
            }

            // 处理批盘分享参数:他人的批盘
            if(curPath.indexOf('comment/othercomment') != -1 && detailData.personInfo.id) {
                // document.title = commentData.otherShareTitle;
                WxShareData.title = DATA.getOtherPipanShareTextByData('wechat', commentData.hideName, commentData.otherShareTitle, detailData.personInfo);
                WxShareData.desc = '点击查看批盘内容。打开后可点击右上角『保存』将批盘内容保存到我的八字库中。';
                shareId = commentData.hideName ? commentData.otherShareCode.nmothershare : commentData.otherShareCode.smothershare;
                WxShareData.linkurl = 'https://' + location.hostname + '/share/comment/' + shareId;
                WxShareData.img = 'https://' + location.hostname + '/dist/share-img-2.png';
            }

            // 处理批盘分享参数:二次转发分享页面
            if(curPath.indexOf('share/comment') != -1 && detailData.personInfo) {
                // document.title = otherShareData.shareTitle;
                WxShareData.title = DATA.getOtherPipanShareTextByData('wechat', commentData.hideName, otherShareData.shareTitle, detailData.personInfo);
                WxShareData.desc = '点击查看批盘内容。打开后可点击右上角『保存』将批盘内容保存到我的八字库中。';
                shareId = otherShareData.shareData && otherShareData.shareData.shareInfo ? commentData.hideName ? otherShareData.shareData.shareInfo.nm : otherShareData.shareData.shareInfo.sm : '';
                WxShareData.linkurl = 'https://' + location.hostname + '/share/comment/' + shareId;
                WxShareData.img = 'https://' + location.hostname + '/dist/share-img-2.png';
            }

            // 处理论盘分享参数
            if(curPath.indexOf('discuss/') != -1 && detailData.personInfo) {
                // document.title = discussData.lunpanData.title;
                WxShareData.title = DATA.getLunPanShareTextByData('wechat', discussData.lunpanData.title, detailData.personInfo);
                WxShareData.desc = '点击进入在线论盘，论盘记录将永久保存在对应八字下面的论盘记录中，可随时查阅。';
                if(discussData.lunpanData && discussData.lunpanData.shareCode) {
                    shareId = discussData.hideName ? discussData.lunpanData.shareCode.nmlpshare : discussData.lunpanData.shareCode.smlpshare;
                }
                if(discussData.lunpanData && discussData.lunpanData.share) {
                    shareId = discussData.lunpanData.share;
                }
                let fromPage = curPath.indexOf('share') != -1 ? location.pathname.split('/')[4] : location.pathname.split('/')[2];
                WxShareData.linkurl = 'https://' + location.hostname + '/share/discuss/'+fromPage+'/'+shareId;
                WxShareData.img = 'https://' + location.hostname + '/dist/share-img-3.png';
            }

            // 处理异常情况:恢复成默认的情况
            if(!shareId){
                WxShareData.title = baseTitle;
                WxShareData.desc = '专业好用的八字软件；支持手机和电脑使用；让易学数据世代相传。';
                WxShareData.linkurl = 'https://' + location.hostname;
                WxShareData.img = 'https://' + location.hostname + '/dist/logo.png';
            }

            // 处理捐赠页面分享参数
            if(curPath.indexOf('donate') != -1) {
                var donateTitle = donateData && donateData.myNum && donateData.myNum != 0 ? 
                    ('助力传统文化复兴，我是第' + donateData.myNum + '位文化复兴大使！') :
                    '助力传统文化复兴，我来点燃星火！';
                // document.title = donateTitle;
                WxShareData.title = donateTitle;
                WxShareData.desc = '文化复兴，功在当代，利在千秋。';
                WxShareData.linkurl = 'https://' + location.hostname + '/donate/collate';
                WxShareData.img = 'https://' + location.hostname + '/dist/share-img-4.png';
                console.error('donate-----', WxShareData)
            }

            // 导入页面
            if(curPath.indexOf('import') != -1) {
                WxShareData.linkurl = 'https://' + location.hostname + '/import';
            }
            
            // 处理百科页面分享参数
            if(curPath.indexOf('famouspedia') != -1) {
                var famousTitle = '名人八字百科',
                    famousUrl = 'https://' + location.hostname + '/famouspedia';
                if(curPath.indexOf('/famouspediaread') != -1) {
                    var famousBaziInfo = famouspediaData.curPediaBaziInfo;
                    famousTitle = famousBaziInfo ? DATA.getFamousPediaShareTextByData('wechat', famousBaziInfo) : famousTitle;
                    famousUrl = famousBaziInfo ? 'https://' + location.hostname + '/share/famouspediaread/' + famousBaziInfo.id + '/famouspedia' : famousUrl;
                }
                // document.title = famousTitle;
                WxShareData.title = famousTitle;
                WxShareData.desc = '点击可查看名人生平事迹及与之对应的各位易友的论断。';
                WxShareData.linkurl = famousUrl;
                WxShareData.img = 'https://' + location.hostname + '/dist/share-img-5.png';
                console.log('famouspedia-----initConfigShare', curPath, famousBaziInfo)
            }

            if(curPath.indexOf('marriagereport') != -1) {
                var marriageDesc = '点击可查看朋友分享的姻缘测算报告';
                var marriageUrl = 'https://' + location.hostname;
                if(curPath.indexOf('marriagereportone') != -1) {
                    marriageUrl = marriageUrl+'/share/marriagereportone/'+marriageShareCode;
                }else if(curPath.indexOf('marriagereporttwo') != -1) {
                    marriageUrl = marriageUrl+'/share/marriagereporttwo/'+marriageShareCode;
                }
                WxShareData.title = '八字姻缘测算';
                WxShareData.desc = marriageDesc;
                WxShareData.linkurl = marriageUrl;
                WxShareData.img = 'https://' + location.hostname + '/dist/share-img-6.png';

                console.log('marriageShareCode-----', marriageShareCode, WxShareData);
            }

            // 简单处理一下分享
            if(curPath.indexOf('diagram') != -1) {
                WxShareData.linkurl = 'https://' + location.hostname + '/diagram';
                document.title = '天时六爻';
            }else {
                document.title = '天时子平八字';
            }

            console.log("getWeixinSdkConfig----配置成功", shareId, WxShareData);

            // 页面加载完成后用户就有可能调用微信的分享，所以当页面ready 完后就加载
            wx.ready(function () {
                var commonShareData = {
                    // 分享标题
                    title: WxShareData.title,
                    // 分享描述
                    desc: WxShareData.desc,
                    // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    link: WxShareData.linkurl,
                    // 分享图标
                    imgUrl: WxShareData.img,
                    success: function () {
                        console.log('分享回调函数');
                        if(sucFunc && typeof(sucFunc) == 'function'){
                            sucFunc();
                        }
                    },
                }
                wx.onMenuShareTimeline(commonShareData);//1.0
                wx.updateTimelineShareData(commonShareData);//1.0
                wx.onMenuShareAppMessage(commonShareData)//1.4
                wx.updateAppMessageShareData(commonShareData)//1.4
            });

            // 微信预加载失败回调
            wx.error(function (res) {
                console.error(res);
                if(!UA.isPcWeChat()) {
                    // alert('微信预加载失败回调');
                    // window.location.href = window.location.origin+'/record';
                    // window.location.href = window.location.origin; //授权失败回调跳转回首页
                }
                if(shareTimes < 5) {
                    setTimeout(() => {
                        WEIXIN.initConfigShare(null, null, true);
                    }, 1000);
                }else {
                    fundebug.notify('weixin', 'weixinSdk', {metaData: res});
                }
                if(failFunc && typeof(failFunc) == 'function'){
                    failFunc();
                }
            });
        }, updateShareTime);
    }
}

export {
    WEIXIN, WEIXIN_CHAT, WEIXIN_PAY
}